import {ActivatedRouteSnapshot, BaseRouteReuseStrategy} from '@angular/router';

// 'tickets' and 'ticket-details/:id' are separate route entries pointing at the same
// TicketsComponent (a persistent split-pane, not two full-page views). Angular's default strategy
// only reuses a component when future/current share the exact same route config object, so without
// this override every ticket click would destroy and rebuild TicketsComponent from scratch.
const REUSABLE_TICKET_PATHS = new Set(['tickets', 'ticket-details/:id']);

function ticketRoutePath(route: ActivatedRouteSnapshot): string | undefined {
    return route.routeConfig?.path;
}

export class TicketsRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        const futurePath = ticketRoutePath(future);
        const currPath = ticketRoutePath(curr);
        if (futurePath && currPath && REUSABLE_TICKET_PATHS.has(futurePath) && REUSABLE_TICKET_PATHS.has(currPath)) {
            return true;
        }
        return super.shouldReuseRoute(future, curr);
    }
}
